import { stylesheet } from 'typestyle';
import { flexRoot, horizontal } from 'csstips';

export default stylesheet({
  container: {
    position: 'relative',
    height: 67,
    borderBottom: '1px solid #e1e1e1',
    borderTop: '1px solid #e1e1e1',
    zIndex: 2,
    order: 4,

    br: {
      display: 'none'
    },

    '@media (min-width: 360px) and (max-width: 529px)': {
      height: 134
    },

    $nest: {
      '@media (min-width: 530px) and (max-width: 649px)': {
        height: 110,

        '& br:nth-of-type(3)': {
          display: 'block'
        }
      },

      '@media (min-width: 390px) and (max-width: 529px)': {
        '& br:nth-of-type(2)': {
          display: 'block'
        }
      },

      '@media (min-width: 0px) and (max-width: 389px)': {
        '& br:nth-of-type(1)': {
          display: 'block'
        }
      },

      '@media (min-width: 0px) and (max-width: 359px)': {
        height: 177,

        '& br:nth-of-type(3)': {
          display: 'block'
        }
      }
    }
  },

  style: {},
  styleTab: {
    width: 103,

    '@media (max-width: 649px)': {
      borderBottom: 'none'
    }
  },
  styleContent: {
    width: 198,

    $nest: {
      '@media (min-width: 360px) and (max-width: 649px)': {
        '&::after': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 101,
          width: 'calc(100% - 101px)'
        }
      },

      '@media (min-width: 0px) and (max-width: 359px)': {
        left: -50,

        '&::before': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 0,
          width: 50
        },

        '&::after': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          right: 0,
          width: 45
        }
      }
    }
  },

  metal: {},
  metalTab: {
    width: 100,

    '@media (max-width: 649px)': {
      borderBottom: 'none'
    }
  },
  metalContent: {
    width: 198,

    $nest: {
      '@media (min-width: 0px) and (max-width: 649px)': {
        '&::after': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 98,
          width: 'calc(100% - 98px)'
        }
      }
    }
  },

  priceRange: {},
  priceRangeTab: {
    width: 144,

    '@media (min-width: 530px) and (max-width: 649px)': {
      borderBottom: 'none'
    },

    '@media (min-width: 0px) and (max-width: 359px)': {
      borderBottom: 'none'
    }
  },
  priceRangeContent: {
    width: 313,

    ul: {
      ...flexRoot,
      ...horizontal,
      width: 226,
      justifyContent: 'space-between',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: '15px !important'
    },

    li: {
      marginBottom: 3
    },

    $nest: {
      '& input[type="radio"] + label': {
        margin: 0
      },

      // Reset bottom margin on component container
      '& > [class^=container]': {
        margin: '0 auto',
        height: 'auto'
      },

      '@media (min-width: 650px) and (max-width: 699px)': {
        left: -50
      },

      '@media (min-width: 600px) and (max-width: 649px)': {
        left: -100,

        '&::before': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 0,
          width: 100
        },

        '&::after': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 242,
          width: 70
        }
      },

      '@media (min-width: 550px) and (max-width: 599px)': {
        left: -150,

        '&::before': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 0,
          width: 150
        },

        '&::after': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          right: 0,
          width: 19
        }
      },

      '@media (min-width: 530px) and (max-width: 549px)': {
        left: 'auto',
        right: 0,

        '&::before': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 0,
          width: 169
        }
      },

      '@media (min-width: 380px) and (max-width: 389px)': {
        left: -100
      },

      '@media (min-width: 0px) and (max-width: 379px)': {
        left: -120
      },

      '@media (min-width: 0px) and (max-width: 359px)': {
        '&::before': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 0,
          width: 120
        },

        '&::after': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          right: 0,
          width: 49
        }
      }
    }
  },

  design: {},
  designTab: {
    width: 115,

    '@media (min-width: 390px) and (max-width: 649px)': {
      borderBottom: 'none'
    },

    '@media (min-width: 0px) and (max-width: 359px)': {
      borderBottom: 'none'
    }
  },
  designContent: {
    width: 198,

    $nest: {
      '@media (min-width: 460px) and (max-width: 649px)': {
        '&::before': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          right: 0,
          width: 83
        }
      },

      '@media (min-width: 410px) and (max-width: 459px)': {
        left: 'auto',
        right: -30,

        '&::before': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 0,
          width: 53
        },

        '&::after': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          right: 0,
          width: 30
        }
      },

      '@media (min-width: 390px) and (max-width: 409px)': {
        left: 'auto',
        right: 0,

        '&::before': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          left: 0,
          width: 83
        }
      },

      '@media (min-width: 0px) and (max-width: 359px)': {
        '&::before': {
          content: `''`,
          height: 1,
          background: '#e1e1e1',
          position: 'absolute',
          top: 0,
          right: 0,
          width: 83
        }
      }
    }
  },

  contour: {
    position: 'relative',
    display: 'inline-block',
    marginLeft: 30,
    paddingLeft: 20,
    paddingRight: 15,

    $nest: {
      '& label': {
        color: '#7f7f7f'
      },

      '& [type=checkbox]': {
        display: 'none'
      },
      '& label::before': {
        left: -25,
        top: 6
      },
      '& label::after': {
        left: -22,
        top: 9
      },

      '@media (min-width: 360px) and (max-width: 389px)': {
        position: 'absolute',
        top: 21,
        right: 20,

        '& .include': {
          display: 'none'
        }
      },

      '@media (min-width: 360px) and (max-width: 409px)': {
        '& .styles': {
          display: 'none'
        }
      },

      '@media (min-width: 650px) and (max-width: 749px)': {
        '& .styles': {
          display: 'none'
        }
      },

      '@media (min-width: 650px) and (max-width: 699px)': {
        '& .include': {
          display: 'none'
        }
      },

      '@media (min-width: 866px) and (max-width: 890px)': {
        marginLeft: 23
      },

      '@media (max-width: 865px)': {
        marginLeft: 18
      }
    }
  }
});
